const colors = {
    black: '#868786',
    color1: '#868786',
    color2: '#96C400',
    color3: '#CFA22E',
    darkGray: '#929292',
    basketGray: '#EAEAEA',
    darkerGray: '#737373',
    green: '#69b802',
    lightGreen: '#96C400',
    header: '#F8F8F8',
    lightGray: '#EAEAEA',
    midGray: '#C4C4C4',
    warning: '#EB5757',
    lightWarning: 'rgba(235, 87, 87, 0.20)',
    white: '#FFFFFF',
    basketInfoIcon: 'rgba(34, 34, 34, 0.54)',
    buttonPrimaryColor: '#69b802',
    optionItemMainColor: '#96C400',
    optionItemBorderColor: '#96C400',
    optionItemBackgroundColor: '#96C400',
    optionItemFontColor: '#FFFFFF',
    productCategoryCardBorderColor: '#96C400',
    productCategoryCardHeadBGColor: '#96C400',
    productCategoryCardBGColor: '#96C400',
    productCategoryCardFontColor: '#FFFFFF',
    configurationItemBackgroundColorHead: 'transparent',
    configurationItemBackgroundColorCard: '#96C400',
    configurationItemTextColor: '#FFFFFF',
    configurationItemBorderColor: '#96C400',
    orderVerificationEdit: '#96C400',
}

export default colors
